import React from 'react';
import { Configuration, PublicClientApplication } from '@azure/msal-browser';

import { getConfig } from '../config';

interface Props {
  children: (pca: PublicClientApplication) => React.ReactElement;
}

/**
 * This component will create a PublicClientApplication object and return it to the child renderer.
 * This is done because we must wait for the config to be loaded before creating the target object
 */
const PublicClientApplicationWrapper: React.FC<Props> = ({ children }) => {
  const applicationConfiguration = getConfig();

  const configuration: Configuration = {
    auth: {
      clientId: applicationConfiguration.auth.appId,
      redirectUri: window.location.origin,
      authority: `https://login.microsoftonline.com/${applicationConfiguration.auth.tenantName}`,
    },
  };
  const pca = new PublicClientApplication(configuration);

  return children(pca);
};

export default PublicClientApplicationWrapper;
